/**
 * User: danielgw
 * Date: 3/30/16
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseFilterViewController = require('web-agent-viewControllers/BaseFilterViewController');

    var FilterButtonSelectViewController = BaseFilterViewController.extend({
        ControllerName: 'FilterButtonSelectViewController',
        LPViewMap: {
            buttonsArea: ".lpview_buttonsArea",
            button: ".lpview_button",
            buttonClass: ".lpview_button_"
        },
        LPClassesMap: {
            active: "active",
            button: "lpview_button_"
        },

        initialize: function (constructorData) {
            this.selectedTag = {};
            this.filterName = constructorData.filterName;
            this.filterTextSuffix = constructorData.filterTextSuffix;
            this.titleText = "{{filter_title_" + this.filterTextSuffix + "}}";
            this.filterPrefix = "status";
            this.buttons = constructorData.buttons;
            this.ButtonsNumber = this.buttons.length;
            this.multiple = constructorData.multiple;

            // preset filters
            if (constructorData.defaultFilter) {
                this.filterResetData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterUIData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterData = lpUtils.cloneObject(constructorData.defaultFilter);
            }

            this.initializeView();
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.button, DOMEvent: "click", callback: this.buttonClicked});
        },

        render: function () {
            this.onShow();
        }
    });

    FilterButtonSelectViewController.prototype.initializeView = function () {
        var buttonsHTML = "";
        var textInjection;
        var buttonTemplate = require("web-agent-templates/LP_filter_single_button_select_view.html");
        // var buttonTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_single_button_select_view.html");
        for(var i= 0, l = this.buttons.length; i < l; i++){
            textInjection = {
                tooltipText : this.buttons[i].tooltipText,
                buttonId    : this.buttons[i].buttonId,
                iconClass   : this.buttons[i].iconClass,
                iconType    : this.buttons[i].iconType,
                buttonText  : this.buttons[i].buttonText
            };
            if (i === 0) {
                textInjection.buttonClass  = "first";
            }
            buttonsHTML += this.injectTextDefaults(buttonTemplate, textInjection);

        }
        var filterTemplate = require("web-agent-templates/LP_filter_button_select_view.html");
        // var filterTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_button_select_view.html");
        textInjection = {
            title: this.titleText,
            buttons: buttonsHTML,
            ignoreEscapeHTML: true
        };
        filterTemplate = this.injectTextDefaults(filterTemplate, textInjection);
        this.createView({template: filterTemplate, target: this.LPViewMap.filterArea });

    };

// Set the filter width according to the size of the buttons
    FilterButtonSelectViewController.prototype.setFilterSize = function () {
        var buttons = this.getElements(this.LPViewMap.button);
        var buttonsMaxWidth = 0;
        for (var i = 0; i < buttons.length; i++) {
            if (buttons[i].offsetWidth > buttonsMaxWidth) {
                buttonsMaxWidth = buttons[i].offsetWidth;
            }
        }
        var buttonSideMarginTotal = this.getComputedStyle(this.LPViewMap.button, "margin-left", 10) * 2;
        var mainDiv = this.getFirstElement(this.LPViewMap.main_div);

        this.setStyle(mainDiv, {width: ((buttonsMaxWidth + buttonSideMarginTotal) * this.ButtonsNumber) + "px"});
    };

// When a button clicked, identify the button and active the button logic on it.
    FilterButtonSelectViewController.prototype.buttonClicked = function (data) {
        var that = this;

        var clickedBtn = _.find(this.buttons, function(button){
            return that.hasClass(data.currentTarget, that.LPClassesMap.button + button.buttonId)[0] === true;
        });

        if (!clickedBtn) {
            return;
        }

        if (this.multiple) {

            var selections = this.getSelections();

            var statusIdx = _.findIndex(selections, function (status) {
                return status === clickedBtn.status;
            });

            //toggle button selection data
            if (statusIdx > -1) {
                selections.splice(statusIdx, 1);
            } else {
                selections.push(clickedBtn.status);
            }

            this.filterUIData[this.filterPrefix] = selections.join(",");

        } else {
            // set filter UI data according to the selection
            this.filterUIData[this.filterPrefix] = clickedBtn.status;
        }

        // update UI
        this.updateFilterUI();
    };

    FilterButtonSelectViewController.prototype.onShow = function () {
        this.updateFilterUI();
        this.setFilterSize();
        // preset buttons
        BaseFilterViewController.prototype.onShow.call(this);
    };

    FilterButtonSelectViewController.prototype.getSelections = function () {
        return this.filterUIData[this.filterPrefix] ? this.filterUIData[this.filterPrefix].split(",") : [];
    };

// set the buttons according to the data in the filter
    FilterButtonSelectViewController.prototype.updateFilterUI = function () {
        var that = this;

        this.removeClassMultiElements(this.LPViewMap.button, this.LPClassesMap.active);

        var selections = this.getSelections();

        var classActionFunc =
            this.multiple ?
                function (element, className) {
                    var exists = this.hasClass(element, className)[0];
                    this.toggleClass(element, className, !exists);
                } : this.addClass;


        this.buttons.forEach(function (button) {
            if (_.contains(selections, button.status)) {
                classActionFunc.call(that, that.LPViewMap.buttonClass + button.buttonId, that.LPClassesMap.active);
            }
        });

    };

    return FilterButtonSelectViewController;

});
